// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetSensorMeasurementsRequestModel from '../../model/get-sensor-measurements-request-model';
import GetSensorMeasurementsRequestDTO from '../dto/get-sensor-measurements-request-dto';
import dtoSchema from '../schemas/get-sensor-measurements-request-schema';

export default abstract class GetSensorMeasurementsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetSensorMeasurementsRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.from = data.from;
      this.until = data.until;
      this.selectedCustomer = data.selectedCustomer;
      this.selectedProject = data.selectedProject;
      this.selectedSensorId = data.selectedSensorId;
      this.selectedSensorTyp = data.selectedSensorTyp;
      this.selectedSensorConfig = data.selectedSensorConfig;
      this.id = data.id;
      this.key = data.key;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {date-time}
  */
  from?: string;
  /**
  * @type {date-time}
  */
  until?: string;
  /**
  */
  selectedCustomer?: string;
  /**
  */
  selectedProject?: string;
  /**
  */
  selectedSensorId?: string;
  /**
  */
  selectedSensorTyp?: string;
  /**
  */
  selectedSensorConfig?: string;
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  key?: string;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetSensorMeasurementsRequestDTO>): GetSensorMeasurementsRequestModel;
  static toModel(dto: DeepPartial<GetSensorMeasurementsRequestDTO> | undefined | null): GetSensorMeasurementsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetSensorMeasurementsRequestDTO> | undefined | null): GetSensorMeasurementsRequestModel | undefined {
    return dto ? new GetSensorMeasurementsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetSensorMeasurementsRequestModel> | GetSensorMeasurementsRequestModel): GetSensorMeasurementsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      from: unwrapped.from,
      until: unwrapped.until,
      selectedCustomer: unwrapped.selectedCustomer,
      selectedProject: unwrapped.selectedProject,
      selectedSensorId: unwrapped.selectedSensorId,
      selectedSensorTyp: unwrapped.selectedSensorTyp,
      selectedSensorConfig: unwrapped.selectedSensorConfig,
      id: unwrapped.id,
      key: unwrapped.key,
      searchCriteria: unwrapped.searchCriteria,
    } as GetSensorMeasurementsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetSensorMeasurementsRequestModel, can not map to GetSensorMeasurementsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
